import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
    selector   : 'eguard-notify-popup',
    templateUrl: './notify-popup.component.html',
    styleUrls: ['./notify-popup.component.scss']


})
export class NotifyPopupComponent implements OnInit
{
    public message: string;
    public title: string;

    constructor(public dialogRef: MatDialogRef<NotifyPopupComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any){

    }

    ngOnInit()
    {
        this.message = this.data.message;
        this.title = this.data.title;
    }

}



// WEBPACK FOOTER //
// ./src/app/main/content/common/notify-popup/notify-popup.component.ts